<script>
import Multiselect from 'vue-multiselect'
import UploadFile from '@components/upload-file'

export default {

    components: { Multiselect, UploadFile },

    props: {

    },

    data() {
        return {}
    },

    watch: {

    },

    computed: {

    },

    async mounted() {

    },

    methods: {

    }
}
</script>

<template>
    <div>

        <b-form-group
            label="Параметры"
            label-for="set_variables"
        >
            <b-form-textarea
                id="set_variables"
                v-model="$parent.set_variables"
                placeholder="$var1 = 'текст';"
                rows="4"
            ></b-form-textarea>
        </b-form-group>

    </div>
</template>
